import React from 'react'

const DriveIcon = (props) => {
  return (
   
 
    <svg width="16" height="17" viewBox="0 0 16 17"  fill={props.fill} className={props.className} xmlns="http://www.w3.org/2000/svg">
<path d="M10.0833 13.9993C9.5 13.9993 9.00694 13.798 8.60417 13.3952C8.20139 12.9924 8 12.4993 8 11.916C8 11.3327 8.20139 10.8396 8.60417 10.4368C9.00694 10.0341 9.5 9.83268 10.0833 9.83268C10.6667 9.83268 11.1597 10.0341 11.5625 10.4368C11.9653 10.8396 12.1667 11.3327 12.1667 11.916C12.1667 12.4993 11.9653 12.9924 11.5625 13.3952C11.1597 13.798 10.6667 13.9993 10.0833 13.9993ZM2.16667 17.3327C1.70833 17.3327 1.31583 17.1696 0.989167 16.8435C0.663055 16.5168 0.5 16.1243 0.5 15.666V3.99935C0.5 3.54102 0.663055 3.14879 0.989167 2.82268C1.31583 2.49602 1.70833 2.33268 2.16667 2.33268H3V0.666016H4.66667V2.33268H11.3333V0.666016H13V2.33268H13.8333C14.2917 2.33268 14.6842 2.49602 15.0108 2.82268C15.3369 3.14879 15.5 3.54102 15.5 3.99935V15.666C15.5 16.1243 15.3369 16.5168 15.0108 16.8435C14.6842 17.1696 14.2917 17.3327 13.8333 17.3327H2.16667ZM2.16667 15.666H13.8333V7.33268H2.16667V15.666ZM2.16667 5.66602H13.8333V3.99935H2.16667V5.66602Z" />
</svg>

  )
}

export default DriveIcon
